var __decorate=this&&this.__decorate||function(e,t,o,s){var n,i=arguments.length,r=i<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,o):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,o,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(i<3?n(r):i>3?n(t,o,r):n(t,o))||r);return i>3&&r&&Object.defineProperty(t,o,r),r};import{css as e,html as t}from"lit";import{OrElement as o}from"@openremote/or-element";import{countBadgeStyle as s}from"./styles";import{customElement as n,property as i,state as r}from"lit/decorators.js";import{AssetModelUtil as a}from"@openremote/model";import{formatCount as d,getMarkerIconAndColorFromAssetType as p}from"../util";import{Util as l}from"@openremote/core";import{OrMapBaseControl as c}from"./base";import"@openremote/or-vaadin-components/or-vaadin-checkbox";import"@openremote/or-vaadin-components/or-vaadin-badge";import"@openremote/or-icon";import"@openremote/or-vaadin-components/or-vaadin-list-box";import"@openremote/or-vaadin-components/or-vaadin-item";export class OrMapLegendEvent extends CustomEvent{constructor(e){super(OrMapLegendEvent.NAME,{bubbles:!0,composed:!0,detail:e})}}OrMapLegendEvent.NAME="or-map-legend-changed";let OrMapLegend=class extends o{constructor(){super(...arguments),this.assetTypes=[],this.excludedTypes=[],this.assetCounts={},this._contentHidden=!0,this._assetTypesInfo={}}static get styles(){return[s,e`
        :host {
          display: block;
        }

        #legend {
          display: flex;
          flex-direction: column;
          min-width: 220px;
        }

        #legend-title {
          height: 38px;
          line-height: 38px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: var(--lumo-border-radius-m);
          font-family: var(--lumo-font-family);
          font-size: 16px;
          color: black;
          cursor: pointer;
          padding: 0 20px;
        }
        #legend-title.expanded {
          border-radius: var(--lumo-border-radius-m) var(--lumo-border-radius-m) 0 0;
        }

        or-icon {
          --or-icon-width: 18px;
          --or-icon-height: 18px;
          margin-right: 4px;
        }

        or-vaadin-item {
          min-height: 30px;
          padding: 4px 16px;
          margin: 0 4px;
          box-sizing: border-box;
          font-size: var(--lumo-font-size-m);
          /* Remove hover highlight */
          --lumo-primary-color-10pct: transparent;
          cursor: pointer;
        }
        or-vaadin-item:last-child {
          margin-bottom: 4px;
        }

        or-vaadin-item::part(checkmark) {
          display: none;
        }

        /* List: flat top connecting to title, rounded bottom */
        #legend-list {
          min-width: 220px;
          margin: 0;
          background: var(--lumo-base-color, white);
          border-radius: 0 0 var(--lumo-border-radius-m) var(--lumo-border-radius-m);
          max-height: 0;
          overflow: hidden;
          opacity: 0;
          transition:
            max-height 0.14s ease,
            opacity 0.1s ease;
        }

        #legend-list.expanded {
          max-height: 600px;
          opacity: 1;
        }
      `]}shouldUpdate(e){return e.has("assetTypes")&&(this._assetTypesInfo={},this.assetTypes.forEach(e=>{var t,o;let s=a.getAssetDescriptor(e);this._assetTypesInfo[e]={icon:null==(t=p(s))?void 0:t.icon,color:null==(o=p(s))?void 0:o.color,label:l.getAssetTypeLabel(s)}})),super.shouldUpdate(e)}_setExcluded(e,t){t!==this.excludedTypes.includes(e)&&(this.excludedTypes=t?[...this.excludedTypes,e]:this.excludedTypes.filter(t=>t!==e),this.dispatchEvent(new OrMapLegendEvent(this.excludedTypes)))}_toggleType(e){this._setExcluded(e,!this.excludedTypes.includes(e))}render(){if(this.assetTypes.length<2)return t``;let e=[...this.assetTypes].sort((e,t)=>{var o,s,n,i;return(null!=(s=null==(o=this._assetTypesInfo[e])?void 0:o.label)?s:e).localeCompare(null!=(i=null==(n=this._assetTypesInfo[t])?void 0:n.label)?i:t)});return t`
      <div id="legend">
        <div
          id="legend-title"
          class="${!this._contentHidden?"expanded":""}"
          @click="${()=>{this._contentHidden=!this._contentHidden}}"
        >
          <or-translate value="mapPage.legendTitle"></or-translate>
          <or-icon
            style="cursor: pointer"
            icon="${this._contentHidden?"mdi:chevron-up":"mdi:chevron-down"}"
          ></or-icon>
        </div>
        <or-vaadin-list-box id="legend-list" class="${this._contentHidden?"":"expanded"}">
          ${e.map(e=>{var o;return t`
              <or-vaadin-item @click="${()=>this._toggleType(e)}">
                <div style="display: flex; align-items: center; width: 100%; gap: 6px; min-width: 200px;">
                  <or-icon
                    icon="${this._assetTypesInfo[e].icon}"
                    style="color: #${this._assetTypesInfo[e].color}; flex-shrink: 0; --or-icon-width: 20px; --or-icon-height: 20px;"
                  ></or-icon>
                  <span style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    ${this._assetTypesInfo[e].label}
                  </span>
                  <or-vaadin-badge style="flex-shrink: 0;"
                    >${d(null!=(o=this.assetCounts[e])?o:0)}</or-vaadin-badge
                  >
                  <or-vaadin-checkbox
                    .checked="${!this.excludedTypes.includes(e)}"
                    @click="${e=>e.stopPropagation()}"
                    @change="${t=>{let o=t.currentTarget.checked;this._setExcluded(e,!o)}}"
                  ></or-vaadin-checkbox>
                </div>
              </or-vaadin-item>
            `})}
        </or-vaadin-list-box>
      </div>
    `}};__decorate([i({type:Array})],OrMapLegend.prototype,"assetTypes",void 0),__decorate([i({type:Array})],OrMapLegend.prototype,"excludedTypes",void 0),__decorate([i({type:Object})],OrMapLegend.prototype,"assetCounts",void 0),__decorate([r()],OrMapLegend.prototype,"_contentHidden",void 0),OrMapLegend=__decorate([n("or-map-legend")],OrMapLegend);export class OrMapLegendControl extends c{constructor(e,t,o){super(),this._assetTypes=e,this._excludedTypes=t,this._assetCounts=o}onAdd(e){return this._createContainer(),this._container.classList.add("legend-control"),this._component=document.createElement("or-map-legend"),this._component.assetTypes=this._assetTypes,this._component.excludedTypes=this._excludedTypes,this._component.assetCounts=this._assetCounts,this._container.appendChild(this._component),this._container}onRemove(){super.onRemove(),this._component=void 0}update(e,t){let o=new Set(this._assetTypes);(e.length!==o.size||e.some(e=>!o.has(e)))&&(this.assetTypes=e),this.assetCounts=t}clear(){this.assetTypes=[],this.assetCounts={},this.excludedTypes=[]}set assetTypes(e){this._assetTypes=e,this._component&&(this._component.assetTypes=e)}set assetCounts(e){this._assetCounts=e,this._component&&(this._component.assetCounts=e)}set excludedTypes(e){this._excludedTypes=e,this._component&&(this._component.excludedTypes=e)}get element(){return this._component}}export{OrMapLegend};